import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Platform',
    to: '/#platform'
  }, {
    name: 'Capabilities',
    to: '/#capabilities'
  }, {
    name: 'AI Transformation',
    to: '/services/ai-native-engineering'
  }, {
    name: 'Security',
    to: '/#security'
  }, {
    name: 'About Us',
    to: '/#about'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/90 backdrop-blur-md border-b border-white/10 py-4' : 'bg-transparent py-6'}`} data-id="element-213" data-mp="1kyooefp9j0r9">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between gap-6" data-id="element-214" data-mp="em9a8add4vt2">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 flex-shrink-0" data-id="element-215" data-mp="jn6quiiq5hsg">
          <img src="https://cdn.magicpatterns.com/uploads/4MwpWUASBxAuCwNdk51yeZ/fiqis3.png" alt="FIQIS Logo" className="w-9 h-9 object-contain" data-id="element-216" data-mp="om04cay0h8sm" />
          <span className="text-xl font-bold tracking-wider text-white" data-id="element-217" data-mp="3s1nst8i5uvr2">
            FIQIS
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-7" data-id="element-218" data-mp="u2x6x5ib4xu">
          {navLinks.map(link => <Link key={link.name} to={link.to} className="text-sm font-medium text-gray-300 hover:text-white transition-colors whitespace-nowrap" data-id="element-219" data-mp="5oz22xvudmsd">
              {link.name}
            </Link>)}
          <a href="https://calendly.com/arthur-w-miller/30min" target="_blank" rel="noopener noreferrer" className="bg-teal hover:bg-teal-400 text-navy font-semibold px-5 py-2.5 rounded-md transition-colors duration-200 hover:shadow-[0_0_15px_rgba(0,212,170,0.4)] text-sm whitespace-nowrap" data-id="element-220" data-mp="31a87benx6p4f">
            Request Meeting
          </a>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen} data-id="element-221" data-mp="2iei45o493moy">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-222" data-mp="2nb8q2s2qlcia" /> : <MenuIcon className="w-6 h-6" data-id="element-223" data-mp="2nduz6w5a002m" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-224" data-mp="2l9nky4gnvn2">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:hidden bg-slate border-b border-white/10 overflow-hidden" data-id="element-225" data-mp="2krhzavws52h">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-226" data-mp="svtl50rb5t0b">
              {navLinks.map(link => <Link key={link.name} to={link.to} className="text-base font-medium text-gray-300 hover:text-white py-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-227" data-mp="xtv13ctftc7k">
                  {link.name}
                </Link>)}
              <a href="https://calendly.com/arthur-w-miller/30min" target="_blank" rel="noopener noreferrer" className="bg-teal text-navy font-semibold px-5 py-3 rounded-md mt-2 w-full text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-228" data-mp="1bsbajbiopgte">
                Request Meeting
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}